import { endpoint } from "views/pages/manage/common/constant";
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

export const updateChequeStatusAPI = (requestPayload) => {
  const url = `${endpoint.cashManagement.chequeDashboard.updateChequeStatus}`;

  return fetchAllPostPromisedData(url, requestPayload, "POST");
};


export const chequeDateExtensionAPI = (requestPayload) => {
  const url = `${endpoint.cashManagement.chequeDashboard.sendForApproval}`;
  return fetchAllPostPromisedData(url, requestPayload, "POST");
};

export const chequeRevokeAPI = (requestPayload) => {
  const url = `${endpoint.cashManagement.chequeDashboard.revokeCheque}`;
  return fetchAllPostPromisedData(url, requestPayload, "POST");
};
